<template>
  <b-container fluid style="padding-top: 10px">
    <b-row>
      <b-col cols="1">

      </b-col>
      <b-col cols="10">
        <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="Notification Type:" label-for="input-sm">
          <b-form-select :options="notificationTypes"
                         v-model="selectedNotificationId"
          >
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="1">

      </b-col>
    </b-row>
    <b-row>
      <b-col cols="1">

      </b-col>
      <b-col cols="10">
        <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="Date To Check:" label-for="input-sm">

          <datepicker v-model="dateToCheck" name="certDatePicker" :inline="true"
                      style="width: 50%"/>
        </b-form-group>
      </b-col>
      <b-col cols="1">

      </b-col>
    </b-row>
    <b-row>
      <b-col cols="4">

      </b-col>
      <b-col cols="4">
        <b-button @click="retrieveAlerts" :disabled="selectedNotificationId===null || dateToCheck === null"
                  :variant="selectedNotificationId===null || dateToCheck === null ? 'outline-primary' : 'success'"> See
          Alerts
        </b-button>
      </b-col>
      <b-col cols="4">
      </b-col>
    </b-row>

    <vue-good-table
        v-if="true"
        :columns="columns"
        :rows="rows"
        styleClass="vgt-table condensed table-bordered table-striped"

        :sort-options="{
                    enabled: true,
                    initialSortBy: {
                        field: 'nextAlertYear',
                        type: 'desc'
                    }
                }"
        :pagination-options="{
                    enabled: true,
                    mode: 'records',
                    perPage: 50,
                    position: 'top',
                    perPageDropdown: [50, 100, 200],
                    dropdownAllowAll: false,
                    setCurrentPage: 1,
                    nextLabel: 'next',
                    prevLabel: 'prev',
                    rowsPerPageLabel: 'Rows per page',
                    ofLabel: 'of',
                    pageLabel: 'page', // for 'pages' mode
                    allLabel: 'All',
                }">
      <template slot="table-row" slot-scope="props">
                <span v-if="props.column.label === 'Account Info'">
                    <b-button size="sm"
                              @click="goToAccountInfo(props.column.field,props.formattedRow[props.column.field])">
                            Account Info
                    </b-button>
                </span>
        <span v-else-if="props.column.label === 'Calculator'">
                    <b-button size="sm"
                              @click="goToCalculator(props.formattedRow[props.column.field])">Metrics Summary</b-button>
                </span>
        <span v-else-if="props.column.label === 'Certify'">
                    <b-button size="sm"
                              @click="certify(props.formattedRow['surveyId'], data.item.winery, props.formattedRow['groupId'])">
                    Certify
                    </b-button>
                </span>
        <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                </span>
      </template>
    </vue-good-table>
  </b-container>
</template>
<script>
import Datepicker from 'vuejs-datepicker';
// import the styles
import 'vue-good-table/dist/vue-good-table.css'
import {VueGoodTable} from 'vue-good-table';

export default {
  name: "UpcomingAlertView",
  components: {
    Datepicker,
    VueGoodTable
  },
  data() {
    return {
      columns: [
        {
          label: "Next Alert Month",
          field: "nextAlertMonth"
        },
        {
          label: "nextAlertYear",
          field: "nextAlertYear"
        },
        {
          label: "emailRecipient",
          field: "emailRecipient"
        },
        {
          label: "recipientName",
          field: "recipientName",
        },
        {
          label: "subType",
          field: "subType",
        },
        {
          label: "groupId",
          field: "groupId",
          formatFn: value => {
            return groupList.find(group => group.id === value).name;
          }
        }
      ],
      items: [],
      rows: [],
      dateToCheck: '',
      surveyToCertify: '',
      groupIdToCertify: '',
      notificationTypes: [{value: null, text: 'Please select an option'}, {
        text: "Desk Audit",
        value: "deskAudit"
      }, {text: "Recertification Alert", value: "recertAlert"}],
      selectedNotificationId: null,
      saveButtonVariant: "outline-primary",
      groupList: []
    }
  },
  mounted() {
    this.$http.get(`account/deskAudit/${new Date().getMilliseconds()}`)
        .then(result => {
          this.rows = result.data;
        })
        .catch(error => {
          console.log("The error: " + error);
        });
    this.$http.get("groups")
        .then(resp => {
          self.groupList = resp.data;
        }).catch(error => {
      this.$toasted.show(`Unable to retrieve groups.`,
          {
            containerClass: 'super-toasty',
            iconPack: 'fontawesome',
            closeOnSwipe: true,
            action: {
              text: 'DISMISS',
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              }
            },
            icon: {
              name: 'fa-skull-crossbones',
              after: false,
            }
          })
          .goAway(5000);
    });

  },
  methods: {
    isNotCertifier: function () {
      return !localStorage.getItem("roles").includes("THIRD_PARTY_CERTIFIER");
    },
    selected: function (item) {
      localStorage.setItem('adminImpersonationGroupId', item.groupId);
      this.$router.push({name: 'SurveyLink', params: {surveyKey: item.surveyId, groupId: item.groupId}});
    },
    retrieveAlerts: function () {
      //this.$http.get("account/recertAlert/1733029200000")
      let self = this;
      console.log("Retrieve Alerts");
      console.log(typeof self.dateToCheck);
      console.log(self.dateToCheck);
      console.log(self.dateToCheck.getTime());
      let dateToCheckMillis = self.dateToCheck.getTime();
      self.rows = [];
      let url = `account/${self.selectedNotificationId}/${dateToCheckMillis}`;
      console.log("Url: " + url);
      this.$http.get(url)
          .then(result => {
            console.log("Results: {}", result.data);
            this.rows = result.data;
          })
          .catch(error => {
            console.log("The error: " + error);
          })
    }
  }
}
</script>
